module.exports = __webpack_public_path__ + "img/sv.7cb7b810.svg";